import { InjectionToken } from '@angular/core';
import { Company } from '@lx/shared/types';

export const COMPANY = new InjectionToken<Company>('COMPANY');
